import { request } from '@langlois/request';

export async function getById ({ commit }, competitionId) {
	try {
		const url = new URL(`${process.env.VUE_APP_API_URI}/club/competition/${competitionId}`);

		const response = await request.get(url);

		if (response.ok) {
			const competition = await response.json();

			commit(`setCompetition`, competition);
		}
	} catch (error) {
		return commit(`vcl/notificationBar/show`, {
			text: `Encountered an error while retrieving the competition.`,
			type: `warning`
		}, { root: true });
	}
}
